import {defineMessages} from 'react-intl';

export default defineMessages({
	addToCartLabel: {
		id: 'productDetailDescription.addToCartLabel',
		defaultMessage: 'Add to bag',
	},
	preOrderNow: {
		id: 'productDetailDescription.preOrderNow',
		defaultMessage: 'Pre-order Now',
	},
	notifyMeLabel: {
		id: 'productDetailDescription.notifyMeLabel',
		defaultMessage: 'Notify me',
	},
	sizeGuide: {
		id: 'flyouts.wishlist.sizeGuide',
		defaultMessage: 'size guide',
	},
	sizeSelector: {
		id: 'productDetail.sizeSelector',
		defaultMessage: 'Select size'
	},
	sizeSelectorSelected: {
		id: 'productDetail.sizeSelectorSelected',
		defaultMessage: 'Size'
	},
	productCode: {
		id: 'productDetail.productCode',
		defaultMessage: 'Product Code:'
	}
});
